import React from "react";
import { getFormattedDate } from "../../functions/time";
import SearchIcon from "@mui/icons-material/Search";

const BottomHeader = ({
  headerParams,
  handleEnterKey,
  handleChange,
  length,
}) => {
  return (
    <>
      <div className="stats">
        <div className="stat">
          <p className="stat-title">Bookmarks</p>
          <p>{length}</p>
        </div>
        <div className="stat">
          <p className="stat-title">Created</p>
          <p>{getFormattedDate(headerParams.created)}</p>
        </div>
        <div className="stat">
          <p className="stat-title">Last Modified</p>
          <p>{getFormattedDate(headerParams.updated)}</p>
        </div>
      </div>

      <div className="search-within-collection" onKeyDown={handleEnterKey}>
        <SearchIcon />
        <input
          type="text"
          placeholder="Search bookmarks"
          onChange={(e) => handleChange(e.target.value.trim())}
        />
      </div>
    </>
  );
};

export default BottomHeader;
